<template>
    <div class="favorite-projects">
        <div class="section-title-desc section-title-desc-favorite" v-if="empty">
            <h2>В избранном 0 жилых комплексов</h2>
        </div>
        <!-- {{projectItems}} -->
        <salesFilter></salesFilter>
        <salesItems></salesItems>
    </div>
</template>

<script>
    import salesItems from '@/components/sales/sale-item.vue'
    import salesFilter from '@/components/sales/sales-filter.vue'
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'favorite-projects',
        components: {
            salesItems,
            salesFilter
        },
        data () {
            return {
                empty: false,
                title: 'Жилые комплексы',
            }
        },
        computed: mapGetters({
            projectItems: 'loadProjectItems',
        }),
        methods: {
            checkForEmpty() {
                // Счетчик избранных карточек из LocalStorage
                var items = localStorage.getItem('favorite_projects');
                items = items ? items.split(',') : [];
                if (items.length == 0) {
                    this.empty = true;
                } else {
                    this.empty = false;
                }
                // console.log(items.length);
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.projectItems != null) {
                next(vm => {
                    vm.checkForEmpty();
                    vm.$parent.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');

                });
            } else {
                store.dispatch('getProjectsItems').then((response) => {
                    // console.log(resp, 'HOME')
                    if (response) {
                        next(vm => {
                            vm.checkForEmpty();
                            vm.$parent.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getProjectsItems');
        },
        created () {
            this.checkForEmpty();
            this.$store.commit('setCustomCrumb', this.title);
        },
        mounted() {
            this.$store.watch(
                (state) => state.favoriteCount,
                (oldValue, newValue) => {
                    this.checkForEmpty();
                    // console.log('update')
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/favorite/favorite-projects.scss';
</style>